import React, { useState } from "react";
import { Link } from "react-router-dom";
import LoginModal from "./LoginModal";
import { useAuth } from "../../context/AuthContext"; // importa el context

function Navbar() {
  const { user, logout } = useAuth(); // obtienes user y logout
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const openLoginModal = () => setShowLoginModal(true);
  const closeLoginModal = () => setShowLoginModal(false);

  return (
    <>
      <div className="container-fluid">
        <div className="row border-top px-xl-5">
          <div className="col-lg-3 d-none d-lg-block">
          </div>

          {/* Menú de navegación principal */}
          <div className="col-lg-9">
            <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0 px-0">
              <button
                type="button"
                className="navbar-toggler"
                onClick={toggleMenu}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className={`collapse navbar-collapse justify-content-between ${isMenuOpen ? "show" : ""}`}
                id="navbarCollapse"
              >
                <div className="navbar-nav py-0">
                  <Link to="/" className="nav-item nav-link active" onClick={closeMenu}>Inicio</Link>
                  <Link to="/about" className="nav-item nav-link" onClick={closeMenu}>Conoce al fundador</Link>
                  <Link to="/courses" className="nav-item nav-link" onClick={closeMenu}>Formaciones</Link>
                  <Link to="/contact" className="nav-item nav-link" onClick={closeMenu}>Contacto</Link>
                </div>
                <div className="button-container">
                  <a
                    className="btn btn-primary py-2 px-4 ml-auto d-none d-lg-block"
                    href="https://api.whatsapp.com/send?phone=573028688273&text=Hola%20vengo%20del%20sitio%20web%20y%20estoy%20interesado%20en%20uno%20de%20sus%20cursos.."
                  >
                    Me interesa un curso
                  </a>
                  
                    <button onClick={openLoginModal} className="btn btn-primary btn-login py-2 px-5 ml-auto">
                      Login <i className="fa fa-sign-in-alt"></i>
                    </button>
                  
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>


      {showLoginModal && <LoginModal closeModal={closeLoginModal} />}
    </>
  );
}

export default Navbar;
